<template>
  <div class="plugin-editions mb-4 py-6 lg:flex lg:-mx-4 lg:justify-center">
    <plugin-edition
      v-for="(edition, key) in plugin.editions"
      :key="edition.handle + key"
      :plugin="plugin"
      :edition="edition"
      :class="[
        {
          'lg:w-1/3 lg:mx-4': true,
          'mb-6 lg:mb-0': key < plugin.editions.length,
        },
      ]"
    />
  </div>
</template>

<script>
  import PluginEdition from './PluginEdition';

  export default {
    components: {
      PluginEdition,
    },

    props: {
      plugin: {
        type: Object,
        required: true,
      },
    },
  };
</script>
